import * as PIXI from 'pixi.js';
import Element from '../../Prototype/UI/Element';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import UIComponent from '../UI/UIComponent';

export default class UINineSliceComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.NineSlice;

    public attach(gameObject: Element, params: any): void {
        this.UIComponent = new PIXI.ui.component.NineSlice(
            PIXIRenderer.getTexture(params.data.cacheKey),
            {
                top: params.data.offset[0],
                right: params.data.offset[1],
                bottom: params.data.offset[2],
                left: params.data.offset[3],
            }
        );

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }

    get visible(): boolean {
        return this.UIComponent.nineSlicePlane.visible;
    }

    set visible(value: boolean) {
        this.UIComponent.nineSlicePlane.visible = value;
    }

    get width(): number {
        return this.UIComponent.nineSlicePlane.width;
    }

    set width(value: number) {
        this.UIComponent.nineSlicePlane.width = value;
    }

    get height(): number {
        return this.UIComponent.nineSlicePlane.height;
    }

    set height(value: number) {
        this.UIComponent.nineSlicePlane.height = value;
    }

    get tint(): number {
        return this.UIComponent.nineSlicePlane.tint;
    }

    set tint(value: number) {
        this.UIComponent.nineSlicePlane.tint = value;
    }

    //TODO:
    // public texture: string = undefined;
    // public leftWidth: number = undefined;
    // public topHeight: number = undefined;
    // public rightWidth: number = undefined;
    // public bottomHeight: number = undefined;
}
